var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseLayout',[_c('TheNavBarMinimal'),_vm._v(" "),_c('div',[_c('transition',{attrs:{"name":"fade"}},[_c('Nuxt',{attrs:{"keep-alive":"","keep-alive-props":{ exclude: ['modal'] }}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }